import { useQuery } from "@tanstack/react-query";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { api, errMsg } from "@/lib/api";
import { Page } from "@/components/layout/Layout";
import { Loading, ErrorBox } from "@/components/common/States";
import { AdminProducts, AdminCategories, AdminCorrections } from "./AdminCatalog";
import { AdminReports, AdminUsers, AdminAdmins, AdminSettings } from "./AdminPeople";

export default function Admin() {
  const { data: me, isLoading, error } = useQuery({ queryKey: ["admin-me"], queryFn: async () => (await api.get("/admin/me")).data });
  const { data: stats } = useQuery({ queryKey: ["admin-stats"], queryFn: async () => (await api.get("/admin/stats")).data, enabled: !!me });
  if (isLoading) return <Loading />;
  if (error) return <Page><ErrorBox message={errMsg(error)} /></Page>;
  const can = (p) => me.permissions.includes(p);
  const tabs = [
    can("catalog") && ["products", "Ürünler", <AdminProducts />],
    can("categories") && ["categories", "Kategoriler", <AdminCategories />],
    can("corrections") && ["corrections", "Düzeltme önerileri", <AdminCorrections />],
    can("moderation") && ["reports", "Bildirimler", <AdminReports />],
    can("users") && ["users", "Kullanıcılar", <AdminUsers />],
    me.is_super_admin && ["admins", "Yetkililer", <AdminAdmins allPermissions={me.all_permissions} />],
    me.is_super_admin && ["settings", "Ayarlar", <AdminSettings />],
  ].filter(Boolean);
  return (
    <Page>
      <p className="eyebrow">Yönetim paneli</p>
      <h1 className="font-display text-4xl font-semibold">CreateFPV yönetim</h1>
      {stats && (
        <div className="mt-6 grid grid-cols-2 gap-2 sm:grid-cols-5" data-testid="admin-stats">
          {[["Kullanıcı", stats.users], ["Katalog ürünü", stats.products], ["Aktif ilan", stats.active_listings], ["Açık bildirim", stats.open_reports], ["Bekleyen öneri", stats.pending_corrections]].map(([l, v]) => (
            <div key={l} className="panel p-4"><p className="font-display text-2xl font-semibold">{v}</p><p className="text-xs text-zinc-500">{l}</p></div>
          ))}
        </div>
      )}
      {tabs.length > 0 && (
        <Tabs defaultValue={tabs[0][0]} className="mt-8">
          <TabsList className="flex h-auto flex-wrap justify-start bg-black/[0.03]">
            {tabs.map(([k, l]) => <TabsTrigger key={k} value={k} data-testid={`admin-tab-${k}`}>{l}</TabsTrigger>)}
          </TabsList>
          {tabs.map(([k, , el]) => <TabsContent key={k} value={k} className="mt-6">{el}</TabsContent>)}
        </Tabs>
      )}
    </Page>
  );
}
